import { useMemo } from 'react';

export function HOOK_GRID2D_CELL__icon_size(cell_width: number, cell_height: number) {
  /*
   * METHODS
   */
  const icon_width = useMemo(() => {
    return cell_height > cell_width ? cell_width / 2 : cell_width / 3;
  }, [cell_width, cell_height]);

  const icon_height = useMemo(() => {
    return cell_height > cell_width ? cell_height / 3 : cell_height / 2;
  }, [cell_width, cell_height]);

  return { icon_width, icon_height };
}
